import { useEffect, useState } from "react";
import { errorDetail } from "./api";

/** Loads a payload when `deps` change; `error` is the server's message, `reload` retries. */
export function useLoad<T>(load: () => Promise<T>, deps: unknown[], fallback = "Unable to load this content.") {
    const [state, setState] = useState<{ data: T | null; error: string | null }>({ data: null, error: null });
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let cancelled = false;
        setState({ data: null, error: null });
        load()
            .then(data => !cancelled && setState({ data, error: null }))
            .catch(async error => {
                const message = await errorDetail(error, fallback);
                if (!cancelled) setState({ data: null, error: message });
            });
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps, attempt]);

    return { ...state, loading: !state.data && !state.error, reload: () => setAttempt(value => value + 1) };
}
